module.exports = __webpack_public_path__ + "media/flags/tk-fc6ec362.svg";